export default {
  partner:
    'Définissez vos frais de traitement Stripe ou confirmez une marge de 0 %. D’ici là, vos restaurants sur Stripe ne peuvent pas être mis en ligne.',
  partner_live_one:
    'Définissez vos frais de traitement Stripe ou confirmez une marge de 0 %. D’ici là, vos restaurants sur Stripe ne peuvent pas être mis en ligne, et votre restaurant en ligne n’accepte aucun paiement en ligne.',
  partner_live_other:
    'Définissez vos frais de traitement Stripe ou confirmez une marge de 0 %. D’ici là, vos restaurants sur Stripe ne peuvent pas être mis en ligne, et vos {{count}} restaurants en ligne n’acceptent aucun paiement en ligne.',
  restaurant:
    'Les paiements en ligne sont suspendus tant que votre partenaire n’a pas défini ses frais de traitement. Les paiements en espèces fonctionnent toujours.',
  cta: 'Définir les frais de traitement',
};
